var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var luminosities = [
    10,
    15,
    20,
    30,
    40,
    45,
    50,
    60,
    70,
    85,
    90,
    94,
    96,
    98,
];
function colorGenerator(color, hue, saturation) {
    var colorSet = {};
    for (var index in luminosities) {
        var key = "" + color + luminosities[index];
        colorSet[key] = "hsl(" + hue + ", " + saturation + "%, " + luminosities[index] + "%)";
    }
    return colorSet;
}
function paletteGenerator() {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, colorGenerator('blue', 218, 75)), colorGenerator('gray', 200, 8)), colorGenerator('green', 117, 70)), colorGenerator('orange', 19, 100)), colorGenerator('purple', 288, 34)), colorGenerator('red', 358, 80)), colorGenerator('yellow', 50, 100)), { black: 'black', white: 'white' });
}
export var colors = paletteGenerator();
//# sourceMappingURL=colors.js.map